import { Injectable } from '@angular/core';

import { IBitfToastData } from '@interfaces';
import { EBitfToastVerticalPosition, EBitfToastHorizontalPosition, EBitfUiMessageType } from '@enums';

@Injectable({
  providedIn: 'root',
})
export abstract class BitfToastMessagesService {
  protected defaultToastData: IBitfToastData = {
    type: EBitfUiMessageType.SUCCESS,
    title: '',
    verticalPosition: EBitfToastVerticalPosition.BOTTOM,
    horizontalPosition: EBitfToastHorizontalPosition.CENTER,
    duration: 4000,
    keyboardClose: true,
    closeButtonText: '',
    showCloseButton: false,
  };

  constructor() {}
}
